import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO_URL =
  "https://static.readdy.ai/image/9bd046423ff55e49be43d604c216515f/748f9bdfc4c6ea0c2a13ac200d412f03.png";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Platforms & Apps", path: "/platforms" },
  { label: "Join as BIGO Host", path: "/join-bigo" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-brand-black/95 backdrop-blur-md border-b border-gold/10"
          : "bg-transparent"
      }`}
      style={{ minWidth: "1024px" }}
    >
      <nav className="w-full px-6 md:px-12 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 flex-shrink-0">
          <div className="w-12 h-12 flex items-center justify-center">
            <img
              src={LOGO_URL}
              alt="LittyCity Agency LLC Logo"
              className="w-12 h-12 object-contain"
            />
          </div>
          <div className="hidden lg:block">
            <p className="text-white font-display font-bold text-sm leading-tight tracking-wider">
              THE LITTY<span className="text-gradient-gold">CITY</span>
            </p>
            <p className="text-gold text-xs tracking-[0.2em] font-sans">
              AGENCY LLC
            </p>
          </div>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`relative px-4 py-2 text-sm font-sans font-medium tracking-wide transition-colors duration-300 whitespace-nowrap ${
                  isActive ? "text-gold" : "text-white/80 hover:text-gold"
                }`}
              >
                {link.label}
                {isActive && (
                  <span className="absolute bottom-0 left-4 right-4 h-px bg-gold" />
                )}
              </Link>
            );
          })}
        </div>

        {/* CTA Button */}
        <Link
          to="/contact"
          className="hidden md:flex items-center gap-2 px-5 py-2 border border-gold text-gold text-sm font-medium tracking-widest rounded-full hover:bg-gold hover:text-white transition-all duration-300 whitespace-nowrap"
        >
          Work With Us
        </Link>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-gold"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-brand-black/98 border-t border-gold/10 px-6 py-4 flex flex-col gap-2">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`py-3 text-base font-sans font-medium tracking-wide border-b border-gold/10 ${
                location.pathname === link.path
                  ? "text-gold"
                  : "text-white/80"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
